import DiscoveryForm from "./DiscoveryForm";

export default DiscoveryForm;
